// extracted by mini-css-extract-plugin
module.exports = {"container":"room_photos_section_container__1Yan2"};